import React, { useEffect } from 'react';
import '../styles/11xplay.css'; 

const ElevenXPlayPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="elevenxplay-page">
      <div className='header'>
        <h1>Welcome to <span className='highlight'>11xplay</span> – Your Hub for Premium <span className='highlight'>Online Betting</span></h1>
        <img src="/11xplay.webp" alt="11xplay Logo" className="logo" />
      </div>

      <section className="intro">
        <p>
          Get ready to elevate your betting experience! <span className='highlight'>11xplay</span> brings you top-tier games, live action, and huge win potential — all handpicked by <span className='highlight'>Mahadev</span>. Whether you're a pro or just starting out, this is your one-stop destination for nonstop excitement.
        </p>
        <div className="cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="why-choose">
        <h2>Why Choose <span className='highlight'>11xplay</span>?</h2>
        <ol>
          <li>
            <strong>Unmatched Game Variety:</strong> Dive into a vast collection of casino and sports betting games with endless fun and rewards, powered by <span className='highlight'>Mahadev</span>.
          </li>
          <li>
            <strong>Live Betting Thrills:</strong> Bet in real-time on fan favorites like <span className='highlight'>Andar Bahar, Teen Patti, Baccarat</span>, and more – all streamed live.
          </li>
          <li>
            <strong>Multiple Payment Modes:</strong> Deposit and withdraw easily through <span className='highlight'>UPI, Cards, Net Banking</span>, and more — fast, secure, and hassle-free.
          </li>
          <li>
            <strong>24/7 Expert Support:</strong> Day or night, the <span className='highlight'>Mahadev</span>-backed team is here to assist you whenever you need.
          </li>
        </ol>
        <div className="cta-buttons">
          <a href="https://wa.me/917777039778" className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href="https://wa.me/918440000562" className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="features">
        <h2>Top <span className='highlight'>Features</span> of <span className='highlight'>11xplay</span></h2>
        <ol>
          <li>
            <strong>Instant Transactions:</strong> Quick deposits and lightning-fast withdrawals to keep the action going – recommended by <span className='highlight'>Mahadev</span>.
          </li>
          <li>
            <strong>Live Match Streaming:</strong> Catch every second of your favorite games live, bringing the stadium to your screen.
          </li>
          <li>
            <strong>High Odds, Big Wins:</strong> Enjoy highly competitive odds on sports like <span className='highlight'>Cricket, Football, Tennis</span>, and more – for higher returns.
          </li>
          <li>
            <strong>International Casino Games:</strong> Experience global classics like <span className='highlight'>Blackjack, Roulette, Baccarat</span> with the authentic vibe of Vegas.
          </li>
        </ol>
      </section>

      <section className="getting-started">
        <h2>How to Get Started with <span className='highlight'>11xplay</span></h2>
        <ol>
          <li>
            <strong>Connect on WhatsApp:</strong> Start a chat and request your personalized 11xplay ID – guided by <span className='highlight'>Mahadev</span>.
          </li>
          <li>
            <strong>Share Your Details:</strong> Submit your name, phone number, email, and desired password – it’s fast and easy.
          </li>
          <li>
            <strong>Start Winning:</strong> Once your ID is ready, you’re all set to explore, bet, and win across our massive platform.
          </li>
        </ol>
        <div className="cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="security">
        <h2><span className='highlight'>Your Security</span> Is Our Priority</h2>
        <p>
          At <span className='highlight'>11xplay</span>, your safety comes first. With advanced encryption (SSL), your data and funds remain fully protected. <span className='highlight'>Mahadev</span> ensures every transaction is secure and private.
        </p>
        <p>
          Don’t wait — join the fastest-growing betting platform in the game. <span className='highlight'>11xplay</span> is where excitement meets opportunity. Bet smart, play hard, and win big — with <span className='highlight'>Mahadev</span> by your side.
        </p>
        <div className="cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default ElevenXPlayPage;
